import React, { Component } from 'react';
import { Accordion, AccordionItem } from 'react-foundation-components/lib/global/accordion';
// import FaqData from '../../data/faqs-data.json';

class FaqList extends Component {
  constructor(props) {
    super(props);

    this.handleSingleSelect = this.handleSingleSelect.bind(this)
    this.state = {
      activeKey: 1,
    }
  }

  handleSingleSelect(activeKey) {
    this.setState({ activeKey })
  }

  render() {
    console.log(this.props);

    return (
      <Accordion activeKey={this.state.activeKey} onSelect={this.handleSingleSelect}>
        {this.props.faqs.map((faq, index) =>
          <AccordionItem eventKey={index} key={faq.key} title={faq.question}>
            <span dangerouslySetInnerHTML={{__html: faq.answer}}/>
          </AccordionItem>
        )}
      </Accordion>
    );
  }
}

export default FaqList;



// WEBPACK FOOTER //
// ./src/components/faq-list.js